import React from 'react';
import Icon from "react-icons-kit/Icon";
import { ic_done } from 'react-icons-kit/md/ic_done'
import { KeyValuePair } from 'tailwindcss/types/config';
import { ServiceBox } from './ServiceBox';
import { stringFormatter } from '../../../helpers';

type ServiceProps = {
  services: any[];
  addService: (service: string) => void;
  removeService: (service: string) => void;
  logoSrc: string;
  logoAlt: string;
  serviceText: KeyValuePair<string, string>;
};

export default function Service({ services, addService, removeService, logoSrc, logoAlt, serviceText }: ServiceProps) {
  if(!Array.isArray(services) || services.length === 0) return null;

  const terms = serviceText.Note + ' ' +
    stringFormatter.formatString(serviceText.Statement, `<a href="${serviceText.Link}" target="_blank"> ${serviceText.Terms}</a>`);
  const items = serviceText.Items.split(/[\r|\n]/);

  return (
    <ServiceBox services={services} addService={addService} removeService={removeService} title={serviceText.Label}>
      <div className='tw-hidden md:tw-flex tw-flex-row tw-items-center tw-gap-2'>
        <img height="80" src={logoSrc} alt={logoAlt} />
        <div>
          <div className="">{serviceText.Title}</div>
          <div className="tw-flex tw-flex-row tw-gap-3">{items.map((item, index) => <span key={index}><Icon icon={ic_done} className='sa-text-green' /> {item}</span>)}</div>
          <div className="tw-text-[11px]" dangerouslySetInnerHTML={{ __html: terms }} />
        </div>
      </div>
      <div className='md:tw-hidden tw-flex tw-flex-col'>
        <div className='tw-flex tw-flex-row tw-items-center tw-gap-2 tw-mb-4'>
          <img height="80" src={logoSrc} alt={logoAlt} />
          <div>
            <div className="">{serviceText.Title}</div>
            <div className="tw-flex tw-flex-col">{items.map((item, index) => <span key={index}><Icon icon={ic_done} className='sa-text-green' /> {item}</span>)}</div>
          </div>
        </div>
        <div className="tw-text-[11px]" dangerouslySetInnerHTML={{ __html: terms }} />
      </div>
    </ServiceBox>
  )

}